/**
* @Author: 858834013@qq.com
* @Name: index
* @Date: 2022-08-24
* @Desc:
*/
<template>
  <div class="itemBody">
    <div  class="homemainrTopTj wow fadeInDown" data-wow-delay="0.5s">
      <div class="listTopTj">
        <div class="itemsTopTj">
          <span class="title">隐患统计</span>
          <div class="tjsl">
            <span class="showNumber">{{ hiddenNum.unHandledCount || 0 }}<span class="showDw">个</span></span>
            <span class="showNumber2">{{ hiddenNum.todayCount || 0 }}<span class="showDw2">个</span></span>
          </div>
          <div class="messageTjsl">
            <span class="messageMs">待处理</span>
            <span class="messageMs2">当日新增</span>
          </div>
        </div>
        <div class="itemsTopTj">
          <span class="title">告警统计  </span>
          <div class="tjsl">
            <span class="showNumber">{{ warningNum.unHandledCount || 0 }}<span class="showDw">个</span></span>
            <span class="showNumber2">{{ warningNum.todayCount || 0 }}<span class="showDw2">个</span></span>
          </div>
          <div class="messageTjsl">
            <span class="messageMs">待处理</span>
            <span class="messageMs2">当日新增</span>
          </div>
        </div>
        <div class="itemsTopTj">
          <span class="title">能耗统计 </span>
          <div class="tjsl">
            <span class="showNumber" >{{
                deptEnergyNum.thisWeekDeptEnergy || 0
              }}<span class="showDw">{{ deptEnergyNum.unit }}</span></span>
            <span class="showNumber3">{{
                deptEnergyNum.thisMonthDeptEnergy || 0
              }}<span class="showDw2">{{ deptEnergyNum.unit2 }}</span></span>
          </div>
          <div class="messageTjsl">
            <span class="messageMs">本周用电

              {{
                deptEnergyNum.oneBeforeWeekSamePeriodDeptRingRatio || 0
              }}%</span>
            <span class="messageMs2">本月用电

              {{
                deptEnergyNum.oneBeforeMonthSamePeriodDeptRingRatio || 0
              }}%</span>
          </div>
        </div>
        <div class="itemsTopTj">
          <span class="title">设备统计 </span>
          <div class="tjsl">
            <span class="showNumber">{{ offlineNum.onlineCount || 0 }}<span class="showDw">台</span></span>
            <span class="showNumber2">{{ offlineNum.offlineCount || 0 }}<span class="showDw2">台</span></span>
          </div>
          <div class="messageTjsl">
            <span class="messageMs">在线设备</span>
            <span class="messageMs2">离线设备</span>
          </div>
        </div>
      </div>
    </div>
    <div  class="homemainrCenter wow fadeInDown" data-wow-delay="0.5s">
      <div class="ycBottom">
        <div  class="item11 wow fadeInRight transition"
              data-wow-delay="1s">
          <item>
            <item11  title="隐患待处置"></item11>
          </item>
        </div>
        <div ref="elementBottom"
             class="item12 wow fadeInUp transition"
             data-wow-delay="1s">
          <item>
            <item12  title="报警待处置"></item12>
          </item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import item from '@/components/item/item'
import item11 from '@/components/singlehome/item11'
import item12 from '@/components/singlehome/item12'
import Axios from "@/utils/Axios";
export default {
  components: {item, item11, item12},
  name: "index",
  data() {
    return {
      hiddenNum: {},
      warningNum: {},
      offlineNum: {},
      deptEnergyNum: {
        unit: "",
        unit2: "",
        upIcon: true,
        upIcon2: true,
        thisWeekDeptEnergy: "",
        thisMonthDeptEnergy: "",
        oneBeforeMonthSamePeriodDeptRingRatio: "",
        oneBeforeWeekSamePeriodDeptRingRatio: "",
      },
    }
  },
  watch: {},
  mounted() {
    this.queryWarnNum()
    this.queryHidden()
    this.queryDeptEnergy()
    this.queryOffline()
  },
  methods: {
    queryOffline() {
      let param = {
        method: "post",
        url: "/portal/terminalOnlineStatis",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        this.offlineNum = res.data;
      });
    },
    queryDeptEnergy() {
      let param = {
        method: "post",
        url: "/portal/energyStatis",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        this.deptEnergy(res.data);
      });
    },
    deptEnergy({
                 thisWeekEnergy,
                 oneBeforeWeekSamePeriodRingRatio,
                 thisMonthEnergy,
                 oneBeforeMonthSamePeriodRingRatio,
               })
    {
      switch (thisWeekEnergy > 10000) {
        case true:
          this.deptEnergyNum.thisWeekDeptEnergy = (
            thisWeekEnergy / 10000
          ).toFixed(2);
          this.deptEnergyNum.unit = "万度";
          break;
        default:
          this.deptEnergyNum.unit = "度";
          this.deptEnergyNum.thisWeekDeptEnergy = thisWeekEnergy;
      }
      switch (thisMonthEnergy > 10000) {
        case true:
          this.deptEnergyNum.thisMonthDeptEnergy = (
            thisMonthEnergy / 10000
          ).toFixed(2);
          this.deptEnergyNum.unit2 = "万度";
          break;
        default:
          this.deptEnergyNum.unit2 = "度";
          this.deptEnergyNum.thisMonthDeptEnergy = thisMonthEnergy;
      }
      this.deptEnergyNum.oneBeforeWeekSamePeriodDeptRingRatio =
        oneBeforeWeekSamePeriodRingRatio;
      if (parseInt(oneBeforeWeekSamePeriodRingRatio) > 0) {
        this.deptEnergyNum.upIcon = false;
      } else {
        this.deptEnergyNum.upIcon = true;
      }
      this.deptEnergyNum.oneBeforeMonthSamePeriodDeptRingRatio =
        oneBeforeMonthSamePeriodRingRatio;
      if (parseInt(oneBeforeMonthSamePeriodRingRatio) > 0) {
        this.deptEnergyNum.upIcon2 = false;
      } else {
        this.deptEnergyNum.upIcon2 = true;
      }
    },
    queryWarnNum() {
      let param = {
        url: "/portal/eventCountStatis",
        method: "post",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        if (res.data.unHandledCount != 0 || res.data.totalCount != 0) {
          this.warningNum = res.data;

        } else {

        }
      });
    },
    queryHidden() {
      let param = {
        url: "/portal/sysRiskCountStatis",
        method: "post",
        params: {},
      };
      Axios.ajax(param).then((res) => {
        if (res.data.unHandledCount != 0 || res.data.totalCount != 0) {
          this.hiddenNum = res.data;


        } else {

        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.itemBody {
  position: relative;
  width: 100%;
  height: 60%;
  .homemainrTopTj{
    width: 100%;
    height: 30%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;

    .listTopTj {
     // margin-left: 30px;
      display: flex;
      margin-top: 20px;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
    }

    .itemsTopTj {
      background: url("../../../assets/home/cardBg.png");
      background-size: 100% 100%;
      width: 333px;

      height: 150px;
      opacity: 0.9;
      margin-right: 29px;
      position: relative;
      pointer-events: initial;
      .title {
        display: flex;
        flex-direction: column-reverse;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: flex-end;
        align-items: flex-start;
        margin-top: 8px;
        margin-left: 15px;
        color: white;
        font-size: 20px;
      }
      .tjsl {
        width: 100%;
        color: aliceblue;
        font-size: 20px;
        margin-top: 20px;
        .showNumber{
          display: inline-block;
          font-size: 28px;
          font-weight: bolder;
          width: 50%;
          text-align: center;
        }
        .showDw{
          font-size: 15px;
          margin-left: 10px;
        }
        .showNumber2{
          font-size: 28px;
          display: inline-block;
          width: 50%;
          text-align: center;
          font-weight: bolder;
        }
        .showDw2{

          font-size: 15px;
          margin-left: 10px;
        }
        .showNumber3{
          display: inline-block;
          width: 50%;
          text-align: center;
          font-size: 28px;
          font-weight: bolder;

        }
      }
      .messageTjsl{

        color: aliceblue;
        font-size: 20px;
        margin-top: 10px;
        .messageMs{
          display: inline-block;
          width: 50%;
          text-align: center;
          font-size: 13px;
        }
        .messageMs2{
          display: inline-block;
          width: 50%;
          text-align: center;
          font-size: 13px;

        }
      }
    }

    .itemsTopTj:hover {
      opacity: 1;
    }
  }
  .homemainrCenter{
    width: 100%;
    height: 70%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    pointer-events: initial;
    margin-top: 1.5%;
    .ycBottom {
      width: 100%;
      height: calc(100% - 50px);
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
      pointer-events: initial;

      .item11 {
        width: calc(50% - 20px);
        /* margin-right: 20px;*/
        height: 100%;
      }

      .item12 {
        width: 50%;
        height: 100%;
      }
    }
  }
}
</style>
